import React from "react";
import DashboardLab from "../pages/dashboard/DashboardLab";
import DashboardPharmacy from "../pages/dashboard/DashboardPharmacy";
import NotFound from "../layouts/components/NotFound";
import {isBrowser} from 'react-device-detect';
import MobileDashboardPharmacy from "../pages/dashboard/MobileDashboardPharmacy";
import MobileDashboardLab from "../pages/dashboard/MobileDashboardLab";
const getDashboard = (vendor_type, hist) => {
    switch (vendor_type){
        case 'HOME_CARE':
            return (isBrowser ? <DashboardLab {...hist} /> : <MobileDashboardLab {...hist} />);
        case 'LAB':
            return (isBrowser ? <DashboardLab {...hist} /> : <MobileDashboardLab {...hist} />);
        case 'DRUG':
            return (isBrowser ? <DashboardPharmacy {...hist} /> : <MobileDashboardPharmacy />);
        default:
            return <NotFound />
    }
};

const getMenuList = (vendor_type) => {
    const drug_menu_list = [
        {
            title : 'سفارشهای امروز',
            name : 'vendor_today_orders',
            path : '/panel/dashboard'
        },
        {
            title : 'گزارش سفارش‌ها',
            name : 'vendor_all_orders',
            path: '/panel/order-report'
        },
        {
            title : 'گزارش تراکنش‌ها',
            name : 'vendor_all_transactions',
            path : '/panel/financial-report'
        },
        {
            title : 'حساب کاربری',
            name : 'profile',
            path : '/panel/profile'
        }
    ];
    switch (vendor_type){
        case 'DRUG':
            return drug_menu_list;
        default:
            return [];
    }
};

export {
    getDashboard,
    getMenuList
}